import { Link } from 'react-router-dom';

interface BrandLogoProps {
 isAdmin?: boolean;
 linkTo?: string;
 className?: string;
 showVersion?: boolean;
 serverStatus?: 'offline' | 'online' | 'checking';
}

export function BrandLogo({ isAdmin = false, linkTo = '/', className = '', showVersion = false, serverStatus: _serverStatus }: BrandLogoProps) {

 const version = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '';
 const buildId = typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : '';

  const content = (
  <>
  <div className={`flex-shrink-0 pt-1 md:pt-1.5 -mt-1 md:-mt-1.5 -mb-6 md:-mb-10 relative z-10 bg-surface-card rounded-full ${isAdmin ? 'bg-red-500/15 border border-red-500/30' : ''}`}>
  <img
 src={`${import.meta.env.BASE_URL}jarvis-icon-192.png`}
   alt="Jarvis Interviews logo"
     className={`w-20 h-20 md:w-28 md:h-28 rounded-full object-cover ${isAdmin ? 'brightness-50 sepia saturate-200 hue-rotate-[-50deg]' : ''}`}
     width="112"
     height="112"
    decoding="async"
   />
  </div>
  <div className="flex flex-col justify-center">
  <span className="brand-title text-[16px] min-[360px]:text-[18px] md:text-[22px] font-extrabold tracking-tight text-text-primary leading-none">
  Jarvis
  </span>
  <span className={`text-[13px] min-[360px]:text-[14px] md:text-[17px] font-extrabold tracking-tight leading-none mt-0.5 ${isAdmin ? 'text-red-600 dark:text-red-400' : 'text-purple-600 dark:text-purple-400'}`}>
  {isAdmin ? 'Admin' : 'Interviews'}
  </span>
  {showVersion && !isAdmin && version && (
  <span id="build-version" data-build-id={buildId} className="text-[7px] md:text-[8px] font-mono font-semibold tracking-widest uppercase text-text-muted mt-1.5">
  {version}
  </span>
  )}
  {isAdmin && (
  <span className="text-[9px] md:text-[10px] text-text-muted font-semibold tracking-widest uppercase mt-[-2px]">
  System Control
  </span>
  )}
  </div>
  </>
  );

  return (
  <Link 
  to={linkTo} 
  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
  className={`flex items-center gap-1.5 md:gap-3 transition-all active:scale-95 no-underline shrink-0 ${className}`}
  >
  {content}
  </Link>
  );
}
